export const chartHasNoData = (chart) => {
  const datasets = chart && chart.datasets
  if (!Array.isArray(datasets) || datasets.length === 0) return true
  return datasets.every((dataset) => {
    const data = dataset && dataset.data
    if (!Array.isArray(data) || data.length === 0) return true
    return data.every(
      (value) => value === null || value === undefined || value === 0
    )
  })
}
